import { AxiosError } from 'axios';
import { createAction, Action } from 'deox';

export type ResponseError = { message: string };

type AbstractFailActionCreatorType = (payload: ResponseError) => Action<string, ResponseError>;

export const processRequestError = createAction(
  'errors/PROCESS_REQUEST_ERROR',
  (resolve) => (payload: { error: AxiosError; failAction: AbstractFailActionCreatorType }) =>
    resolve(payload),
);
